import { CreatePage, NavigateBackButton } from '@contember/admin'
import * as React from 'react'
import { SiteField } from '../components'
import { PodcastForm, PodcastFormSide } from '../forms'

export const PodcastCreatePage = (
	<CreatePage
		entity="Podcast"
		pageName="podcastCreate"
		rendererProps={{
			title: 'Add a new podcast',
			side: <PodcastFormSide />,
			navigation: <NavigateBackButton to="podcastList">Podcasts</NavigateBackButton>,
		}}
		redirectOnSuccess={request => ({ ...request, pageName: 'podcastList' })}
	>
		<SiteField />
		<PodcastForm />
	</CreatePage>
)
